<template>
  <div>
    <g-breadcrumb :paginas="paginaStatus.caminhoMigalha" />
    <g-pesquisa
      id="refResultadoPesquisaRequerente"
      name="refResultadoPesquisaRequerente"
      ref="refResultadoPesquisaRequerente"
      :filtroAdicional="getFiltroPesquisa"
      :limparFiltroLocal="limparFiltro"
      :colunasPropriedade=colunasRequerentesDataTable
      :apiPesquisa="apiRequerente"
      :operacoes="operacoes"
      :exibirColunaOperacoes="exibirColunaOperacoes"
      :elementosPorPagina="elementosPorPagina"
      :imprimir="imprimir"
      :novo="novoItem"
      :showCardPesquisa="true"
      :showBuscaAvancada="true"
      :showBuscaAvancadaAberta="true"
      :showTermoPesquisa="false"
      :carregamentoInicial="false"
      :showBotaoNovo="permissaoPerfil.incluir"
    >
      <div class="row">
        <div class="col-sm-7 col-xs-7">
          <!-- <g-input
            id="refNomRequerente"
            name="refNomRequerente"
            ref="refNomRequerente"
            tipo="text"
            etiqueta="Requerente"
            :tamanho="100"
            :foco="false"
            :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
            v-model="requerente.nomRequerente"
          >
          </g-input> -->
          <g-autocomplete
            id="refRequerente"
            name="refRequerente"
            ref="refRequerente"
            etiqueta="Requerente"
            valor="nomRequerente"
            :foco="false"
            descricaoPrimaria="nomeDataNascimentoDocumento"
            :desabilitar="paginaStatus.desabilitarEdicao"
            :api=apiRequerente
            v-model="requerente.nomRequerente"
          >
          </g-autocomplete>
        </div>
        <div
          class="col-sm-3 col-xs-3"
          style="padding-left: 5px;"
        >
          <g-dateInput
            id="refDataNascimento"
            name="refDataNascimento"
            ref="refDataNascimento"
            etiqueta="Data de Nascimento"
            v-model="requerente.dataNascimento"
            :desabilitar="false"
            :somenteLeitura="paginaStatus.desabilitarEdicao"
          >
          </g-dateInput>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 col-xs-4">
          <g-select
            id="refTipoDocumento"
            name="refTipoDocumento"
            ref="refTipoDocumento"
            etiqueta="Tipo de Documento"
            :itens="documentoArray"
            item-valor="codigo"
            item-etiqueta="descricao"
            :foco="false"
            :desabilitar="paginaStatus.desabilitarEdicao"
            v-model="tipoDocumento"
          >
          </g-select>
        </div>
        <div
          v-if="tipoDocumento === 'CPF'"
          class="col-sm-6 col-xs-6"
        >
          <g-input
            id="refTxtDocumento"
            name="refTxtDocumento"
            ref="refTxtDocumento"
            tipo="text"
            etiqueta="CPF"
            mascara="cpf"
            :tamanho="20"
            :foco="false"
            :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
            v-model="requerente.txtDocumento"
            :desabilitar="tipoDocumento == null || tipoDocumento == '' || paginaStatus.desabilitarEdicao"
          >
          </g-input>
        </div>
        <div
          v-else-if="tipoDocumento === 'CNP'"
          class="col-sm-6 col-xs-6"
        >
          <g-input
            id="refTxtDocumento"
            name="refTxtDocumento"
            ref="refTxtDocumento"
            tipo="text"
            etiqueta="CNPJ"
            mascara="cnpj"
            :tamanho="20"
            :foco="false"
            :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
            v-model="requerente.txtDocumento"
            :desabilitar="tipoDocumento == null || tipoDocumento == '' || paginaStatus.desabilitarEdicao"
            :converter-para-maiusculo="true"
          >
          </g-input>
        </div>
        <div
          v-else
          class="col-sm-6 col-xs-6"
        >
          <g-input
            id="refTxtDocumento"
            name="refTxtDocumento"
            ref="refTxtDocumento"
            tipo="text"
            etiqueta="Documento"
            :tamanho="20"
            :foco="false"
            :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
            v-model="requerente.txtDocumento"
            :desabilitar="tipoDocumento == null || tipoDocumento == '' || paginaStatus.desabilitarEdicao"
          >
          </g-input>
        </div>

      </div>
    </g-pesquisa>
  </div>
</template>
<script>
import api from 'components/util/api'
import GInput from 'components/util/gInput'
import GSelect from 'components/util/gSelect'
import GPesquisa from 'components/util/gPesquisa'
import GDatepicker from 'components/util/gDatepicker'
import GBreadcrumb from 'components/util/gBreadcrumb'
import GAutocomplete from 'components/util/gAutocomplete'
import GDateInput from 'components/util/gDateInput'
import constante from 'components/util/constante'

import util from 'components/util/util'
import utilHttp from 'components/util/utilHttp'
import msg from 'components/util/msg'

export default {
  data () {
    return {
      apiRequerente: api.REQUERENTE,
      apiRelRequerente: api.RELATORIO_REQUERENTE,
      apiOrgao: api.ORGAO,
      elementosPorPagina: 10,
      exibirColunaOperacoes: true,
      permissaoPerfil: '',
      datNasc: '',
      requerente: {
        nomRequerente: '',
        txtDocumento: '',
        indTipoDocumento: '',
        dataNascimento: ''
      },
      documentoArray: [{ codigo: 'CPF', descricao: 'CPF' }, { codigo: 'CNP', descricao: 'CNPJ' }, { codigo: 'RG ', descricao: 'RG' },
        { codigo: 'NIS', descricao: 'NIS' }, { codigo: 'PAS', descricao: 'PASSAPORTE' }],
      tipoDocumento: '',
      paginaStatus: {
        requerente: {
          nomRequerente: '',
          txtDocumento: '',
          indTipoDocumento: '',
          dataNascimento: ''
        },
        caminhoMigalha: [
          {
            icone: '',
            descricao: '',
            rotaNome: ''
          }
        ]
      },
      colunasRequerentesDataTable: [
        {
          conteudoTipo: '',
          largura: '30%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Nome',
          conteudoClasse: 'text-left',
          propriedade: 'nomRequerente',
          chave: 'nomRequerente'
        },
        {
          conteudoTipo: '',
          largura: '30%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Documento',
          conteudoClasse: 'text-left',
          propriedade: 'documentoTipo',
          formatar: (valor) => this.formatarDocumento(valor)
        },
        {
          conteudoTipo: '',
          largura: '20%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Data de Nascimento',
          conteudoClasse: 'text-left',
          propriedade: 'dataNascimento',
          formatar: (valor) => util.formatarData(valor, 'dd/mm/yyyy')
        }
      ],

      operacoes: [
        {
          cor: 'blue',
          icone: 'fas fa-search',
          tooltip: 'Visualizar',
          clique: this.visualizarItem,
          permissao: (row) => true,
          visivel: (row) => true
        },
        {
          cor: 'orange',
          icone: 'fas fa-edit',
          tooltip: 'Editar Requerente',
          clique: this.editarItem,
          permissao: (row) => this.permissaoPerfil.alterar,
          visivel: (row) => this.permissaoPerfil.alterar
        },
        {
          cor: 'red',
          icone: 'fas fa-trash',
          tooltip: 'Excluir Requerente',
          clique: this.excluirItem,
          permissao: (row) => this.permissaoPerfil.excluir,
          visivel: (row) => this.permissaoPerfil.excluir
        }
      ]
    }
  },
  methods: {
    imprimir () {
      util.exibirToastInfo(msg.m(12))
    },
    getFiltroPesquisa () {
      var self = this
      var filtro = ''

      self.removerMascaras()
      self.tratarDataNascimento()

      if (self.requerente.nomRequerente) filtro = filtro.concat('&nomRequerente=').concat(self.requerente.nomRequerente)
      if (self.tipoDocumento) filtro = filtro.concat('&indTipoDocumento=').concat(self.tipoDocumento)
      if (self.requerente.txtDocumento) filtro = filtro.concat('&txtDocumento=').concat(self.requerente.txtDocumento)
      if (self.requerente.dataNascimento) filtro = filtro.concat('&dataNascimento=').concat(self.datNasc).concat('T00:00:00.000-00:00')
      return filtro
    },
    limparFiltro () {
      this.requerente = { txtDocumento: '', indTipoDocumento: '', nomRequerente: '', dataNascimento: '' }
      this.tipoDocumento = ''
      this.$refs['refRequerente'].limpar()
    },
    removerMascaras () {
      if (this.tipoDocumento === 'CPF' || this.tipoDocumento === 'CNP') {
        if (this.requerente.txtDocumento !== null && this.requerente.txtDocumento !== '' && this.requerente.txtDocumento !== undefined) {
          this.requerente.txtDocumento = util.limparFormatacaoDocumento(this.requerente.txtDocumento.toString(), constante.TIPO_LIMPEZA_DUCUMENTO[this.tipoDocumento === 'CNP' ? 'CNPJ' : 'CPF'])
        }
      }
    },
    formatarDocumento (valor) {
      var tipoDocumento = valor.substring(0, 3)
      if (tipoDocumento === 'CPF') {
        return ('CPF: ').concat(util.formatarCpf(valor.replace(tipoDocumento, '')))
      } else if (tipoDocumento === 'CNP') {
        return ('CNPJ: ').concat(util.formatarCnpj(valor.replace(tipoDocumento, '')))
      } else if (tipoDocumento === 'PAS') {
        return ('PAS: ').concat(valor.replace(tipoDocumento, ''))
      } else if (tipoDocumento === 'NIS') {
        return ('NIS: ').concat(valor.replace(tipoDocumento, ''))
      } else {
        return ('RG: ').concat(valor.replace(tipoDocumento, ''))
      }
    },
    novoItem () {
      var newPaginaStatus = {
        requerente: {
          nacionalidade: {},
          logradouro: {},
          bairro: {},
          municipio: {},
          uf: {}
        }
      }

      newPaginaStatus.operacao = {
        descricao: 'Novo',
        icone: 'fas fa-plus',
        aberturaProcesso: false
      }
      newPaginaStatus.caminhoMigalha = this.paginaStatus.caminhoMigalha
      newPaginaStatus.desabilitarEdicao = false
      newPaginaStatus.modal = false
      this.$router.push({
        name: 'requerente',
        params: {
          paginaStatus: newPaginaStatus
        }
      })
    },
    editarItem (item) {
      delete item.colunas
      this.paginaStatus.requerente = item
      this.paginaStatus.desabilitarEdicao = false
      this.paginaStatus.modal = false
      this.paginaStatus.requerente.txtEmail = util.validarCampo(this.paginaStatus.requerente.txtEmail) ? this.paginaStatus.requerente.txtEmail.toString().trim() : ''
      this.paginaStatus.operacao = {
        descricao: 'Editar Requerente',
        icone: 'fa fa-edit',
        aberturaProcesso: false
      }
      this.$router.push({
        name: 'requerente',
        params: {
          paginaStatus: this.paginaStatus
        }
      })
    },
    visualizarItem (item) {
      this.paginaStatus.requerente = item
      this.paginaStatus.desabilitarEdicao = true
      this.paginaStatus.modal = false
      this.paginaStatus.requerente.txtEmail = util.validarCampo(this.paginaStatus.requerente.txtEmail) ? this.paginaStatus.requerente.txtEmail.toString().trim() : ''
      this.paginaStatus.operacao = {
        descricao: 'Visualizar',
        icone: 'fa fa-search',
        aberturaProcesso: false
      }
      this.$router.push({
        name: 'requerente',
        params: {
          paginaStatus: this.paginaStatus
        }
      })
    },
    excluirItem (item) {
      var self = this
      util.exibirConfirmacaoExclusao('EXCLUSÃO', msg.m(5), () => {
        utilHttp.httpDeletePorID(self.apiRequerente.concat('/').concat(item.codRequerente), resposta => {
          util.exibirToastSucesso(msg.m(4))
          this.pesquisarPrimeiraPagina()
        })
      })
    },
    pesquisarPrimeiraPagina () {
      this.$refs['refResultadoPesquisaRequerente'].pesquisar(1)
    },
    tratarDataNascimento () {
      var self = this

      if (self.requerente.dataNascimento !== null && self.requerente.dataNascimento !== undefined && self.requerente.dataNascimento !== '') {
        let dn = new Date(util.formatarAnoMesDia(self.requerente.dataNascimento, 'DD/MM/YYYY'))
        let dia = String(dn.getDate()).padStart(2, '0')
        let mes = String(dn.getMonth() + 1).padStart(2, '0')
        let ano = String(dn.getFullYear())

        var dNascimento = ano + '-' + mes + '-' + dia

        self.datNasc = dNascimento
      }
    }
  },
  watch: {
    paginaStatus: {
      handler (valor) {
        if (valor) {
          util.adicionarNoStorage(this.chaveLocalStorage, valor)
        } else util.removerDoStorage(this.chaveLocalStorage)
      },
      deep: true
    },
    tipoDocumento: {
      handler (valor) {
        var self = this
        if (valor === 'CPF' && self.$refs['refTxtDocumento']) {
          self.$refs['refTxtDocumento'].dTamanho = 14
        } else if (valor === 'CNP' && self.$refs['refTxtDocumento']) {
          self.$refs['refTxtDocumento'].dTamanho = 18
        } else {
          self.$refs['refTxtDocumento'].dTamanho = 20
        }
        self.requerente.indTipoDocumento = this.tipoDocumento
        self.requerente.txtDocumento = ''
      }
    }
  },
  mounted () {
    this.paginaStatus.caminhoMigalha = [
      {
        icone: 'fas fa-folder-open',
        descricao: 'Requerente',
        rotaNome: 'requerentePesquisa'
      }
    ]

    // this.pesquisarPrimeiraPagina()
    this.permissaoPerfil = util.montarPermissoes(this.$router.history.current.path)
  },
  components: { GBreadcrumb, GPesquisa, GInput, GAutocomplete, GSelect, GDatepicker, GDateInput }
}
</script>
